<template>
  <div v-if="data">
    <p class="text-uppercase mt-5 mb-5" :class="this.$vuetify.theme.dark ? 'text-white' : 'text-black'"><strong>{{title}}</strong></p>
    <div>
      <template>
        <v-data-table
          :headers="headers"
          :items="data"
          hide-default-footer
          :items-per-page="-1"
          class="elevation-0"
        ></v-data-table>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: ['data', 'headers', 'title'],
  data: function () {
    // Outra forma de passar "classe" que serão "visiveis" para a página de impressão
    // é utilizar o attr :style do vue como se fosse uma classe propriamente dita
    return {
      desserts: []
    }
  }
}
</script>
<style>
/* As classe adicionadas aqui deverão ser passadas no campo 'css' no objeto enviado para a função printerControl.openDialog */
</style>



// WEBPACK FOOTER //
// src/components/impressoes/RelatorioBase.vue